// Accessibility for cart drawer focus management
(function() {
  // Use new attribute for button targeting
  var cartIconButton = document.querySelector('[data-cart-icon-button]');
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var lastFocusedElement = null;

  function trapFocusOnDrawer(e) {
    if (!cartDrawer) return;
    // Handle ESC key to close drawer and return focus
    if (e.key === 'Escape' || e.keyCode === 27) {
      closeDrawer();
      e.preventDefault();
      return;
    }
    const isTabPressed = e.key === 'Tab' || e.keyCode === 9;
    if (!isTabPressed) return;
    const focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
    const focusableContent = cartDrawer.querySelectorAll(focusableElements);
    const firstFocusable = focusableContent[0];
    const lastFocusable = focusableContent[focusableContent.length - 1];
    if (e.shiftKey) {
      if (document.activeElement === firstFocusable) {
        lastFocusable.focus();
        e.preventDefault();
      }
    } else {
      if (document.activeElement === lastFocusable || !cartDrawer.contains(document.activeElement)) {
        firstFocusable.focus();
        e.preventDefault();
      }
    }
  }

  function openDrawer() {
    if (!cartDrawer) return;
    lastFocusedElement = document.activeElement;
    cartDrawer.setAttribute('aria-modal', 'true');
    cartDrawer.setAttribute('tabindex', '-1');
    // Move focus to the close button inside the cart drawer
    var closeBtn = cartDrawer.querySelector('[data-cart-button-close]');
    if (closeBtn) {
      closeBtn.focus();
    } else {
      cartDrawer.focus();
    }
    document.addEventListener('keydown', trapFocusOnDrawer);
  }

  function closeDrawer() {
    if (!cartDrawer) return;
    cartDrawer.removeAttribute('aria-modal');
    cartDrawer.removeAttribute('tabindex');
    document.removeEventListener('keydown', trapFocusOnDrawer);
    if (cartDrawer._removeTrapFocus) cartDrawer._removeTrapFocus();
    // Always return focus to the cart icon button after closing
    if (cartIconButton) {
      setTimeout(function() {
        cartIconButton.focus();
        // Debug: confirm focus
        // console.log('Focus returned to cart icon button after ESC or close');
      }, 100);
    }
  }

  if (cartIconButton) {
    cartIconButton.addEventListener('click', function(e) {
      setTimeout(openDrawer, 100); // Wait for drawer to open
    });
  }

  // Move focus to cart drawer when any [data-add-to-cart-button] is clicked
  var addToCartButtons = document.querySelectorAll('[data-add-to-cart-button]');
  if (addToCartButtons.length) {
    addToCartButtons.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        window._focusCartDrawerOnOpen = true;
      });
    });
  }

  // Listen for cart drawer open events
  document.addEventListener('cart-drawer:open', function() {
    if (window._focusCartDrawerOnOpen) {
      setTimeout(openDrawer, 10); // Move focus after drawer is open
      window._focusCartDrawerOnOpen = false;
    }
  });

  // Listen for cart drawer close events (customize as needed)
  document.addEventListener('cart-drawer:close', closeDrawer);

  // Optionally, detect close button inside cart drawer
  if (cartDrawer) {
    cartDrawer.addEventListener('click', function(e) {
      if (e.target.matches('[data-cart-button-close]')) {
        closeDrawer();
      }
    });
  }
})();
